// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorCard-cls1_M61","cls2":"AuthorCard-cls2_ZvH AuthorCard-cls1_M61"};